import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Chip as ChipOrigin } from 'components/UI'
// views
import { TableFieldWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField/views'
// themes
import { colors } from 'themes/index'

export const Chip = styled(ChipOrigin)`
  && {
    color: ${colors.white};
    font-weight: 500;
    background-color: ${({ color }) => color};
    width: min-content;
  }
`

export const RecurrenceFieldWrapper = styled((props) => <TableFieldWrapper {...props} />)`
  font-size: 14px;
  height: 32px;

  ${Chip} {
    width: auto !important;
  }
`
